const data = [
    {
        id: 1,
        name: "Sculpture Name 1",
        description: "A beautiful sculpture made of marble.",
        price: 32.14,
        images: [
            "https://repository-images.githubusercontent.com/260096455/47f1b200-8b2e-11ea-8fa1-ab106189aeb0",
            "https://hatrabbits.com/wp-content/uploads/2017/01/random.jpg",
            "https://onlineimagetools.com/images/examples-onlineimagetools/color-grid.png",
        ],
        kg: 200,
        dimensionX: 20,
        dimensionY: 60,
    },



    {
        id: 2,
        name: "Sculpture Name 2",
        description: "A beautiful sculpture made of marble.",
        price: 1412.14,
        images: [
            "https://images.unsplash.com/photo-1494253109108-2e30c049369b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fHJhbmRvbXxlbnwwfHwwfHw%3D&w=1000&q=80",
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSfD0Tka3uvKNdwTU3WPj0rRD4atghAI4EUlO1sE2pIFNLGEG9GG-eTSw1AcDO46l0y_2E&usqp=CAU",
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVH7nu_MOD-E8PMuTkhSsAendZBD9QmLtQU13RI0dCfbn6oBQPE0oGi-dj6XSKqmNw-NM&usqp=CAU",
        ],
        kg: 31,
        dimensionX: 12,
        dimensionY: 23,
    },


    {
        id: 3,
        name: "Sculpture Name 3",
        description: "A beautiful sculpture made of marble.",
        price: 3212.14,
        images: [
            "https://thumbs.dreamstime.com/b/random-click-squirrel-wire-random-picture-cute-squirrel-219506797.jpg",
            "https://www.liveabout.com/thmb/7sipcs3AUB_OvuHfCStynK9Pph4=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Dice_by_Ilona_Nagy_GettyImages-629242270-5bcf6a5546e0fb0051f108ea.jpg",
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQr0ndu_tSatLeJOHqQg_5ukCq2JwiQ5U_YUif86SikwSgdqDxcSJDWIUY-UignFlJqZP0&usqp=CAU",
        ],
        kg: 48,
        dimensionX: 19,
        dimensionY: 53,
    },



    

        // // Add more sculptures as necessary
    ];
    
    export default data;
    